import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import { useNativeCountryField } from '../../../lib/hooks/use-native-country-name'
import { HostFamilyInput } from '../../../lib/types/models/host-family/host-family-input'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import { ControlledAdressInput } from '../../elements/inputs/address-input'
import ControlledInput from '../../elements/inputs/controlled-input'

const HostFamilyAddressForm = () => {
  const form = useFormContext<HostFamilyInput>()
  useNativeCountryField(form, 'country')

  return (
    <InnerBox className="p-4 rounded-xl">
      <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
        Address
      </Typography>
      <div className="h-4" />
      <div className="flex flex-col gap-4">
        <FormField
          control={form.control}
          name="address1"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <ControlledAdressInput
                  nativeCountryNames
                  {...field}
                  required
                  label="Address"
                  onDetailsChange={(placeDetails) => {
                    form.setValue('address1', placeDetails.address, { shouldValidate: true })
                    form.setValue('zipCode', placeDetails.postalCode, { shouldValidate: true })
                    form.setValue('city', placeDetails.city, { shouldValidate: true })
                    form.setValue('country', placeDetails.country, { shouldValidate: true })
                    form.trigger(['address1', 'zipCode', 'city', 'country'])
                  }}
                />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="address2"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput {...field} type="text" label="Address complement" />
              </FormControl>
            </FormItem>
          )}
        />
        <div className="flex gap-3">
          <FormField
            control={form.control}
            name="city"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} required type="text" label="Town" />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="zipCode"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} required type="text" label="Zip code" />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
        <FormField
          control={form.control}
          name="country"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput {...field} required type="text" label="Country" />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </InnerBox>
  )
}

export default HostFamilyAddressForm
